export const formatCustomDate = (dateString) => {
  try {
    const [datePart, timePart, period] = dateString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);
    let hours = period.toLowerCase() === "pm" && hour !== 12 ? hour + 12 : hour;
    if (period.toLowerCase() === "am" && hour === 12) hours = 0;
    const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minute));
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: userTimeZone,
    }).format(utcDate);
    const formattedDay = String(day).padStart(2, "0");
    const formattedMonth = utcDate.toLocaleString("en-US", {
      month: "short",
      timeZone: userTimeZone,
    });
    return `${formattedDate} - ${formattedDay} ${formattedMonth}`;
  } catch (err) {
    console.error("Invalid date format:", dateString);
    return "Invalid Date";
  }
};

export const formatCustomTime = (dateString) => {
  try {
    const [datePart, timePart, period] = dateString.split(" ");

    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    let hours = period.toLowerCase() === "pm" && hour !== 12 ? hour + 12 : hour;

    if (period.toLowerCase() === "am" && hour === 12) {
      hours = 0;
    }

    const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minute));

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: userTimeZone,
    }).format(utcDate);
  } catch (err) {
    console.error("Invalid date format:", dateString);
    return "Invalid Date";
  }
};

export const formatTime = (dateString) => {
  try {
    const [datePart, timePart, period] = dateString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    // Convert 12-hour to 24-hour
    let hours = period.toLowerCase() === "pm" && hour !== 12 ? hour + 12 : hour;
    if (period.toLowerCase() === "am" && hour === 12) hours = 0;

    const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minute));
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Format only the time
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: userTimeZone,
    }).format(utcDate);

    return formattedTime; // e.g., "03:00 PM"
  } catch (err) {
    console.error("Invalid date format:", dateString);
    return "Invalid Time";
  }
};
